// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 740px;
  position: relative;
}
:host .container .input-radius input {
  width: 80px;
}
:host .container .input-font-size input {
  width: 80px;
}
:host .container .input-font mat-select {
  width: 160px;
}
:host .field-row {
  display: block;
  margin-bottom: 5px;
}
:host .slider-field span {
  padding-left: 2px;
  text-overflow: clip;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
}
:host .slider-field mat-slider {
  background-color: var(--formSliderBackground);
  height: 29px;
}
:host .slider-small > .mat-slider-horizontal {
  min-width: 80px;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
}
:host .mat-tab-container {
  min-height: 300px;
  height: 60vmin;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 15px;
}
:host .mat-tab-container > div {
  display: block;
}
:host .toolbox {
  float: right;
  line-height: 44px;
}
:host .toolbox button {
  /* margin-right: 8px; */
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-switch/html-switch-property/html-switch-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-switch/html-switch-property/html-switch-property.component.scss"],"names":[],"mappings":"AAEI;EACI,YAAA;EACA,kBAAA;ACDR;ADMY;EACI,WAAA;ACJhB;ADOQ;EACI,WAAA;ACLZ;ADQQ;EACI,YAAA;ACNZ;ADUI;EACI,cAAA;EACA,kBAAA;ACRR;ADWI;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ACTR;ADYI;EACI,6CAAA;EACA,YAAA;ACVR;ADaI;EACI,eAAA;ACXR;ADcI;EACI,uBAAA;ACZR;ADeI;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ACbR;ADgBI;EACI,cAAA;ACdR;ADiBI;EACI,YAAA;EACA,iBAAA;ACfR;ADgBQ;EACI,uBAAA;EACA,iBAAA;ACdZ","sourcesContent":[":host {\n\n    .container {\n        width: 740px;\n        position: relative;\n    \n        .input-radius {\n            // margin-left: 60px;\n    \n            input {\n                width: 80px;\n            }\n        }\n        .input-font-size input {\n            width: 80px;\n        }\n    \n        .input-font mat-select {\n            width: 160px;\n        }\n    }\n    \n    .field-row {\n        display: block;\n        margin-bottom: 5px;\n    }\n    \n    .slider-field span {\n        padding-left: 2px;\n        text-overflow: clip;\n        width: 150px;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n    \n    .slider-field mat-slider {\n        background-color: var(--formSliderBackground);\n        height: 29px;\n    }\n    \n    .slider-small > .mat-slider-horizontal {\n        min-width: 80px;\n    }\n    \n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n    }\n    \n    .mat-tab-container {\n        min-height:300px;\n        height:60vmin;\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding-top: 15px;\n    }\n    \n    .mat-tab-container > div {\n        display: block;\n    }\n\n    .toolbox {\n        float: right;\n        line-height: 44px;\n        button {\n            /* margin-right: 8px; */\n            margin-left: 10px;\n        }\n    }\n}\n",":host .container {\n  width: 740px;\n  position: relative;\n}\n:host .container .input-radius input {\n  width: 80px;\n}\n:host .container .input-font-size input {\n  width: 80px;\n}\n:host .container .input-font mat-select {\n  width: 160px;\n}\n:host .field-row {\n  display: block;\n  margin-bottom: 5px;\n}\n:host .slider-field span {\n  padding-left: 2px;\n  text-overflow: clip;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n:host .slider-field mat-slider {\n  background-color: var(--formSliderBackground);\n  height: 29px;\n}\n:host .slider-small > .mat-slider-horizontal {\n  min-width: 80px;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n}\n:host .mat-tab-container {\n  min-height: 300px;\n  height: 60vmin;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 15px;\n}\n:host .mat-tab-container > div {\n  display: block;\n}\n:host .toolbox {\n  float: right;\n  line-height: 44px;\n}\n:host .toolbox button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
